






















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IPromotionModel, IPromotionUpsellModel } from "../models";
import { BModal } from "bootstrap-vue";
import { Getter } from "vuex-class";
import { AppGetterTypes } from "../store";

@Component
export default class UpsellProductModals extends Vue {
    @Getter(AppGetterTypes.promotion)
    promotion!: IPromotionModel;

    selectedUpsells: number[] = [];

    get upsellProducts(): IPromotionUpsellModel[] {
        if (!this.promotion.upsellProducts) {
            return [];
        }

        return this.promotion.upsellProducts.sort((first, second) =>
            first.sortOrder && second.sortOrder
                ? first.sortOrder - second.sortOrder
                : 0
        );
    }

    async upsellSelected(id: number, index: number): Promise<void> {
        this.selectedUpsells.push(id);

        this.hideModal(index);
    }

    getModal(index: number): BModal | null {
        const modal = this.$refs["upsell_" + index] as Vue[];

        if (!modal || modal.length <= 0) {
            return null;
        }

        return modal[0] as BModal;
    }

    async showUpsells(): Promise<void> {
        const firstModal = this.getModal(0);

        if (!firstModal) {
            return;
        }

        firstModal.$on("hide", () => this.modalHidden(0));
        firstModal.show();
    }

    hideModal(index: number): void {
        const modal = this.getModal(index);

        if (modal) {
            modal.hide();
        }
    }

    modalHidden(index: number): void {
        index++;
        const modal = this.getModal(index);

        if (!modal) {
            this.$emit("upsellsAssigned", this.selectedUpsells);
            this.$emit("finished");

            return;
        }

        modal.$on("hide", () => this.modalHidden(index));
        modal.show();
    }
}
